import { axiosInstance } from "./index";

/** POST /admin_portal/v2/event_requests/export_xls — JSON rows for client-side XLS build. */
export const exportAdminEventRequests = (data, config = {}) =>
  axiosInstance.post("/event_requests/export_xls", data, {
    handlerEnabled: false,
    ...config,
  });
